<template>
    <div class="add-new-contact-modal-wrapper">
        <header class="add-new-contact-modal-header">
            <p class="title">Add new contact</p>
        </header>
        <main class="add-new-contact-modal-main">
            <!-- @TODO: uncomment the following once feature is available -->

            <!-- <div class="invite-contact-wrapper"> -->
            <!--     <p class="title">Invite a new user</p> -->
            <!--     <div class="invite-contact-field"> -->
            <!--         <input -->
            <!--             v-model="formValues.inviteContact" -->
            <!--             class="invite-contact" -->
            <!--             name="inviteContact" -->
            <!--             type="text" -->
            <!--             placeholder="Enter email" -->
            <!--         /> -->
            <!--         <button @click="handleInviteContact" class="invite-contact-btn"> -->
            <!--             Send -->
            <!--         </button> -->
            <!--     </div> -->
            <!--     <div class="share-link-field"> -->
            <!--         <label class="share-link-label" for="shareLink"> -->
            <!--             Share you referral link -->
            <!--         </label> -->
            <!--         <div class="share-link-field-actions"> -->
            <!--             <input -->
            <!--                 v-model="formValues.shareLink" -->
            <!--                 class="share-link" -->
            <!--                 name="shareLink" -->
            <!--                 type="text" -->
            <!--                 placeholder="hedlyner.com/sd439435845/acsdsd....." -->
            <!--             /> -->
            <!--             <button class="copy-text-btn">Copy</button> -->
            <!--             <button class="share-link-btn">Share</button> -->
            <!--         </div> -->
            <!--     </div> -->
            <!-- </div> -->
            <div class="search-contact-wrapper">
                <input
                    v-model="formValues.searchContacts"
                    class="search-contacts"
                    name="searchContacts"
                    type="text"
                    placeholder="Search contacts"
                />
                <div class="searched-contacts">
                    <div v-for="(contact, indx) in renderContacts" :key="indx" class="contact">
                        <img
                            class="contact-avatar"
                            :src="contactAvatar(contact)"
                            alt="contact-avatar"
                        />
                        <p class="contact-name">{{ contactName(contact) }}</p>
                        <button
                            @click="handleAddSuggestedContact(contact)"
                            class="add-contact"
                        >
                            <img
                                class="add-contact-icon"
                                :src="URLS.icons.addContact"
                                alt="add-contact-icon"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </main>
        <footer class="add-new-contact-modal-footer">
            <button @click="emitCloseModal" class="cancel-btn">Cancel</button>
            <button @click="emitCloseModal" class="save-btn">Save</button>
        </footer>
    </div>
</template>
<script>
    import useProfileContacts from '@/composables/useProfileContacts.js'

    export default {
        name: 'AddNewContactModal',
        props: {
            contacts: {
                required: false,
                type: Array,
                default: () => []
            }
        },
        emits: ['close-modal', 'added-contact'],
        data: () => ({
            formValues: {
                inviteContact: '',
                shareLink: '',
                searchContacts: ''
            }
        }),
        computed: {
            contactAvatar: (self) => (contact) =>
                (contact.avatar && contact.avatar.includes('/images/global/default.png')) ||
                !contact.avatar
                    ? self.URLS.icons.defaultContact
                    : contact.avatar,
            renderContacts: (self) => {
                if (self.formValues.searchContacts) {
                    return self.contacts.filter((c) => {
                        return self.filterByName(c)
                    })
                }

                return self.contacts
            },
            contactName: () => (contact) => {
                if (contact.band_name) return contact.band_name
                if (contact.venue_name) return contact.venue_name

                return contact.name
            },
            filterByName: (self) => (c) =>
                c.venue_name
                    ? c.venue_name
                          .toLowerCase()
                          .includes(self.formValues.searchContacts.toLowerCase())
                    : c.name
                          .toLowerCase()
                          .includes(self.formValues.searchContacts.toLowerCase()) ||
                      c.band_name
                    ? c.band_name
                          .toLowerCase()
                          .includes(self.formValues.searchContacts.toLowerCase())
                    : c.name
                          .toLowerCase()
                          .includes(self.formValues.searchContacts.toLowerCase())
        },
        setup(props, context) {
            const { URLS, handleAddSuggestedContact } = useProfileContacts(props, context)

            return {
                URLS,
                handleAddSuggestedContact
            }
        },
        methods: {
            handleInviteContact() {},
            emitCloseModal() {
                this.$emit('close-modal')
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobile: 600px;

    @media screen and (max-width: $mobile) {
        .add-new-contact-modal-wrapper {
            gap: 12px !important;

            .searched-contacts {
                max-height: 60px !important;
            }
        }
    }

    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }

    .add-new-contact-modal-wrapper {
        top: 10%;
        position: absolute;
        background: black;
        border-radius: 32px;
        background: #262626;
        padding: 48px 80px;
        display: flex;
        flex-direction: column;
        gap: 48px;
        z-index: 2;
        max-width: 852px;
        width: 100%;

        .add-new-contact-modal-header {
            .title {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -1.76px;
            }
        }
        .add-new-contact-modal-main {
            display: flex;
            flex-direction: column;
            gap: 24px;

            .invite-contact-wrapper {
                display: flex;
                flex-direction: column;
                gap: 24px;

                .title {
                    color: #dedede;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }

                .invite-contact-field {
                    display: flex;
                    flex-direction: row;
                    gap: 8px;
                    width: 100%;

                    .invite-contact {
                        padding: 12px 16px;
                        border-radius: 12px;
                        border: 1px solid #646464;
                        background: #262626;
                        color: #f5f5f5;
                        width: 100%;
                    }
                    .invite-contact-btn {
                        border-radius: 100px;
                        background: #cdeb09;
                        padding: 11px 30px 12px 30px;
                        min-width: 104px;
                        color: black;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                    }
                }

                .share-link-field {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;

                    .share-link-label {
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 135%;
                        letter-spacing: 0.12px;
                    }
                    .share-link-field-actions {
                        display: flex;
                        flex-direction: row;
                        gap: 8px;

                        .share-link {
                            padding: 12px 16px 16px 16px;
                            border-radius: 12px;
                            border: 1px solid #646464;
                            background: #262626;
                            color: #f5f5f5;
                            width: 100%;
                        }
                        .copy-text-btn {
                            padding: 11px 30px 12px 30px;
                            border-radius: 100px;
                            border: 1px solid #cdeb09;
                            background: #262626;
                            color: #cdeb09;
                            font-family: Instrument Sans;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 120%;
                        }
                        .share-link-btn {
                            padding: 11px 30px 12px 30px;
                            border-radius: 100px;
                            background: #cdeb09;
                            color: black;
                            font-family: Instrument Sans;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 120%;
                        }
                    }
                }
            }

            .search-contact-wrapper {
                display: flex;
                flex-direction: column;
                gap: 24px;

                .search-contacts {
                    padding: 12px 16px 16px 16px;
                    border-radius: var(--3, 12px);
                    border: 1px solid #646464;
                    background: #262626;
                    width: 100%;
                    color: #f5f5f5;
                    background-repeat: no-repeat;
                    background-image: url(/images/icons/search_icon_grey.svg);
                    background-position: 95%;
                }
            }
            .searched-contacts::-webkit-scrollbar {
                width: 8px;
            }
            .searched-contacts::-webkit-scrollbar-track {
                background-color: none;
            }
            .searched-contacts::-webkit-scrollbar-thumb {
                max-height: 64px;
                border-radius: 8px;
                background: #8b8b8b;
            }
            .searched-contacts {
                display: flex;
                flex-direction: column;
                max-height: 487px;
                overflow-y: scroll;

                .contact {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 16px;
                    width: 100%;
                    padding: 16px 0px;
                    border-bottom: 1px solid #646464;

                    .contact-avatar {
                        width: 48px;
                        height: 48px;
                        border-radius: 6px;
                        object-fit: cover;
                    }
                    .contact-name {
                        color: #dedede;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                    }
                    .add-contact {
                        margin-left: auto;
                        background: none;

                        .add-contact-icon {
                            padding: 3px;
                            height: 24px;
                            width: 24px;
                        }
                    }
                }
            }
        }

        .add-new-contact-modal-footer {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            gap: 24px;

            .cancel-btn {
                background: none;
                color: #8b8b8b;
                font-family: Studio Pro;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 120%;
                text-decoration-line: underline;
            }

            .save-btn {
                padding: 7px 30px 9px 30px;
                border-radius: 100px;
                background: #cdeb09;
                color: black;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }
    }
</style>
